import { v4 } from "uuid";

import { window } from "@swa-ui/browser";

let id;

export const getExperienceId = () => {
  if (id === undefined) {
    try {
      if (window.sessionStorage && window.sessionStorage.getItem) {
        const storedId = window.sessionStorage.getItem("experienceId");

        if (storedId !== null && storedId !== undefined) {
          id = storedId;
        }
      }
    } catch (error) {
      // Handle storage access errors
    }

    if (id === undefined) {
      id = v4();
      try {
        if (window.sessionStorage && window.sessionStorage.setItem) {
          window.sessionStorage.setItem("experienceId", id);
        }
      } catch (error) {
        // Handle storage quota errors
      }
    }
  }

  return id;
};

export const setExperienceId = (experienceId) => {
  try {
    if (window.sessionStorage && window.sessionStorage.setItem) {
      window.sessionStorage.setItem("experienceId", experienceId);
    }
  } catch (error) {
    // Handle storage errors
  }
  id = experienceId;
};
